
<mat-card class="element-card kpi-metric-element mat-elevation-z1">
  <mat-card-title class="element-title">
    {{metricLabel}}
  </mat-card-title>
  <mat-card-content>
    <div style="display:flex;" fxLayout="column" fxLayoutAlign="space-around center">
      <div fxLayout="row" fxLayoutAlign="center center" class="kpi-metric-element-text">
        <b class="metric-value">{{metricValue}}</b>
        <i [ngClass]="[getTrendArrowIconClass(metricTrend), getTrendIconColor(metricTrend)]"></i>
      </div>
      <div *ngIf="subtitleOne" class="subtitle">
        <span class="subtitle-label">{{ subtitleOneLabel }}</span>
        <span class="subtitle-value">{{ subtitleOne }}</span>
      </div>
    </div>
    
  </mat-card-content>
</mat-card>